module.exports = __webpack_public_path__ + "img/九玄男.4ceb0b7a.png";